(function () {
  function getLocalizedPlaceholder(input) {
    const dataText = input.getAttribute("data-placeholder-text");
    if (dataText) return dataText.trim();

    const aria = input.getAttribute("aria-label");
    if (aria) return aria.trim();

    if (input.id) {
      const lbl = document.querySelector('label[for="' + input.id + '"]');
      if (lbl) {
        const txt = (lbl.textContent || "").trim();
        if (txt) return txt;
      }
    }

    if (input.getAttribute("placeholder")) return input.getAttribute("placeholder").trim();
    if (input.getAttribute("title")) return input.getAttribute("title").trim();

    return "";
  }

  function setLabelText(label, text) {
    const next = text || "";
    if (label.textContent !== next) label.textContent = next;
  }

  function cleanFilenameText(text) {
    if (!text) return "";

    let s = String(text).replace(/\s+/g, " ").trim();

    // remove common action words that can appear in preview
    s = s.replace(/\b(Remove|Delete|Supprimer|Удалить)\b.*$/i, "").trim();

    // remove file size at the end: "(123 KB)" / "(1.2 MB)"
    s = s.replace(/\(\s*\d+(?:[.,]\d+)?\s*(?:b|bytes?|kb|mb|gb)\s*\)\s*$/i, "").trim();

    // ✅ remove upload progress like "100%" (usually appended)
    s = s.replace(/\s*\d{1,3}\s*%\s*$/g, "").trim();

    // ✅ sometimes glued: ".pdf100%" -> ".pdf"
    s = s.replace(/(\.[a-z0-9]{1,12})\s*\d{1,3}\s*%\s*$/i, "$1").trim();

    // if a fake path appears, keep last segment
    if (/[\\/]/.test(s)) s = s.split(/[\\/]/).pop().trim();

    return s;
  }

  function getNativeSelectedFilename(container) {
    const selectors = [
      ".ginput_preview",
      ".ginput_preview_list li",
      ".gform_fileupload_filename",
      ".gform_fileupload_files li",
    ];

    for (const sel of selectors) {
      const el = container.querySelector(sel);
      if (!el) continue;

      const full = cleanFilenameText(el.textContent || "");
      if (full) return full;
    }

    return "";
  }

  function findUploadContainer(inputOrNode) {
    if (!inputOrNode || !inputOrNode.closest) return null;

    return (
      inputOrNode.closest(".ginput_container_fileupload") ||
      inputOrNode.closest(".gform_fileupload_multifile") ||
      inputOrNode.closest(".gform_fileupload_single") ||
      inputOrNode.closest(".ginput_container") ||
      null
    );
  }

  function ensureLabel(input) {
    const container = findUploadContainer(input);
    if (!container) return null;

    let label = container.querySelector(".gf-file-name");
    if (!label) {
      label = document.createElement("div");
      label.className = "gf-file-name";
      container.appendChild(label);
    }

    label.classList.add("is-visible");

    return { container, label };
  }

  function update(input) {
    const ctx = ensureLabel(input);
    if (!ctx) return;

    const { container, label } = ctx;

    // 1) Normal: file chosen
    if (input.files && input.files.length > 0) {
      setLabelText(label, input.files[0].name);
      container.classList.add("gf-has-file");
      return;
    }

    // 2) After failed validation: GF preview/filename text
    const nativeName = getNativeSelectedFilename(container);
    if (nativeName) {
      setLabelText(label, nativeName);
      container.classList.add("gf-has-file");
      return;
    }

    // 3) No file
    const placeholder = getLocalizedPlaceholder(input);
    if (placeholder) setLabelText(label, placeholder);

    container.classList.remove("gf-has-file");
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('.gform_wrapper input[type="file"]').forEach(update);
  }

  function initAllBurst() {
    setTimeout(() => initAll(document), 0);
    setTimeout(() => initAll(document), 50);
    setTimeout(() => initAll(document), 250);
  }

  // =========================
  // Anti double-open guard (hard mode)
  // =========================
  let reopenBlockUntil = 0;

  function isGfFileInput(el) {
    return (
      el &&
      el.tagName === "INPUT" &&
      el.type === "file" &&
      el.closest &&
      el.closest(".gform_wrapper")
    );
  }

  // 1) Block programmatic input.click() calls right after selection
  (function patchFileClick() {
    const proto = window.HTMLInputElement && window.HTMLInputElement.prototype;
    if (!proto || proto.__gfFileClickPatched) return;
    proto.__gfFileClickPatched = true;

    const originalClick = proto.click;

    proto.click = function () {
      if (isGfFileInput(this)) {
        const now = Date.now();
        if (now < reopenBlockUntil) return;
      }

      return originalClick.apply(this, arguments);
    };
  })();

  // 2) Start lock window when user selects a file
  document.addEventListener(
    "change",
    function (e) {
      const input = e.target;
      if (!isGfFileInput(input)) return;

      // lock for 1s after file selection (tune if needed)
      reopenBlockUntil = Date.now() + 1000;

      update(input);
    },
    true
  );

  // 3) Also block synthetic click events inside upload area (just in case)
  function isInFileUploadArea(node) {
    return !!(
      node &&
      node.closest &&
      node.closest(".ginput_container_fileupload, .gform_fileupload_multifile, .gform_fileupload_single")
    );
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!isInFileUploadArea(e.target)) return;

      // block synthetic click events
      if (e.isTrusted === false) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // =========================

  document.addEventListener("DOMContentLoaded", function () {
    initAllBurst();
  });

  document.addEventListener(
    "submit",
    function (e) {
      if (!e.target || !e.target.closest(".gform_wrapper")) return;
      initAllBurst();
    },
    true
  );

  if (window.gform && typeof window.gform.addAction === "function") {
    window.gform.addAction("gform_post_render", initAllBurst);
    window.gform.addAction("gform_page_loaded", initAllBurst);
    window.gform.addAction("gform_post_validation", initAllBurst);
  }

  if (window.jQuery) {
    window.jQuery(document).on(
      "gform_post_render gform_page_loaded gform_post_validation",
      function () {
        initAllBurst();
      }
    );
  }
})();
